type StatusColor = {
    color: string;
    backgroundColor: string;
}

function statusToColor(status: string) {
    switch(status) {
        case "전체":
            return { color: "#3E63ED", backgroundColor: "#E3E8FF" };
        case "안전":
            return { color: "#13A82A", backgroundColor: "#E3FFE7" };
        case "주의":
            return { color: "#FFA500", backgroundColor: "#FFF8E8" };
        case "경보":
            return { color: "#EC0D19", backgroundColor: "#FFE2E2" };
        case "점검":
            return { color: "#3D454D", backgroundColor: "#EAEAEA" };
        default:
            return { color: "#3E63ED", backgroundColor: "#3E63ED" };
    }
}

export default statusToColor;
